import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

// Official recumbent (adaptive) bike icon - 37x22 line art supplied by product.
export default function RecumbentBikeIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 37 22">
      <path
        d="M12.7377 14.0477C12.7377 10.8652 10.1578 8.28538 6.9754 8.28538C3.79298 8.28538 1.21311 10.8652 1.21311 14.0477C1.21311 17.2301 3.79298 19.81 6.9754 19.81C10.1578 19.81 12.7377 17.2301 12.7377 14.0477ZM13.9508 14.0477C13.9508 17.9001 10.8278 21.0231 6.9754 21.0231C3.12299 21.0231 0 17.9001 0 14.0477C0 10.1953 3.12299 7.07227 6.9754 7.07227C10.8278 7.07227 13.9508 10.1953 13.9508 14.0477Z"
        fill="currentColor"
      />
      <path
        d="M35.7877 16.1703C35.7877 14.1604 34.1583 12.531 32.1484 12.531C30.1384 12.531 28.509 14.1604 28.509 16.1703C28.509 18.1803 30.1384 19.8097 32.1484 19.8097C34.1583 19.8097 35.7877 18.1803 35.7877 16.1703ZM37.0008 16.1703C37.0008 18.8503 34.8283 21.0228 32.1484 21.0228C29.4684 21.0228 27.2959 18.8503 27.2959 16.1703C27.2959 13.4904 29.4684 11.3179 32.1484 11.3179C34.8283 11.3179 37.0008 13.4904 37.0008 16.1703Z"
        fill="currentColor"
      />
      <path
        d="M14.3002 9.80348L30.3739 11.0166C30.708 11.0418 30.9583 11.333 30.9331 11.667C30.9079 12.001 30.6167 12.2513 30.2827 12.2262L14.3761 11.0256L7.24718 14.5902C6.94755 14.74 6.58312 14.6185 6.4333 14.3189C6.28349 14.0193 6.40497 13.6548 6.70459 13.505L13.9833 9.86568L14.0206 9.84865C14.1087 9.81179 14.2045 9.79627 14.3002 9.80348Z"
        fill="currentColor"
      />
      <path
        d="M30.1022 11.0582C30.4132 10.9338 30.7662 11.0851 30.8906 11.3961L32.7102 15.9453C32.8346 16.2563 32.6833 16.6093 32.3723 16.7337C32.0613 16.8581 31.7083 16.7068 31.5839 16.3958L29.7642 11.8466C29.6398 11.5356 29.7911 11.1826 30.1022 11.0582Z"
        fill="currentColor"
      />
      <path
        d="M28.7396 6.00504C29.0616 5.91264 29.3976 6.09879 29.49 6.42078L31.4213 13.1509C31.5137 13.4729 31.3275 13.8089 31.0056 13.9013C30.6836 13.9937 30.3475 13.8075 30.2551 13.4856L28.3238 6.75546C28.2314 6.43347 28.4176 6.09745 28.7396 6.00504Z"
        fill="currentColor"
      />
      <path
        d="M26.9919 11.3183C26.9919 10.6483 26.4487 10.1052 25.7788 10.1052C25.1088 10.1052 24.5657 10.6483 24.5657 11.3183C24.5657 11.9883 25.1088 12.5314 25.7788 12.5314C26.4487 12.5314 26.9919 11.9883 26.9919 11.3183ZM28.205 11.3183C28.205 12.6583 27.1187 13.7445 25.7788 13.7445C24.4388 13.7445 23.3525 12.6583 23.3525 11.3183C23.3525 9.97835 24.4388 8.89209 25.7788 8.89209C27.1187 8.89209 28.205 9.97835 28.205 11.3183Z"
        fill="currentColor"
      />
      <path
        d="M25.3943 10.8486C25.6536 10.6364 26.0357 10.6746 26.2479 10.9339L27.6126 12.6019C27.8247 12.8611 27.7866 13.2433 27.5273 13.4555C27.2681 13.6676 26.8859 13.6294 26.6738 13.3702L25.309 11.7021C25.0969 11.4429 25.1351 11.0607 25.3943 10.8486Z"
        fill="currentColor"
      />
      <path
        d="M19.0385 7.834C19.3713 7.79622 19.6718 8.03547 19.7096 8.36829C19.7474 8.70111 19.5081 9.00159 19.1753 9.03942L12.5032 9.79761C12.1704 9.83539 11.8699 9.59615 11.832 9.26332C11.7943 8.9305 12.0335 8.63002 12.3663 8.5922L19.0385 7.834Z"
        fill="currentColor"
      />
      <path
        d="M9.80072 1.95319C10.1155 1.83872 10.4635 2.00106 10.578 2.31585L13.0042 8.98798C13.1187 9.30278 12.9564 9.65077 12.6416 9.76527C12.3268 9.87975 11.9788 9.71741 11.8643 9.40261L9.43806 2.73049C9.32358 2.41568 9.48592 2.06769 9.80072 1.95319Z"
        fill="currentColor"
      />
      <path
        d="M19.6771 4.48769C19.9935 4.59775 20.1607 4.9434 20.0507 5.25978L18.0733 10.944C17.9632 11.2603 17.6175 11.4277 17.3011 11.3177C16.9847 11.2076 16.8174 10.8618 16.9275 10.5454L18.905 4.86131C19.0151 4.54493 19.3607 4.37765 19.6771 4.48769Z"
        fill="currentColor"
      />
      <path
        d="M7.85016 1.75053C7.5719 1.56402 7.49755 1.18733 7.68406 0.909062C7.87057 0.630807 8.24727 0.556458 8.52553 0.742964L10.3596 1.97223C10.6378 2.15875 10.7122 2.53544 10.5257 2.8137C10.3392 3.09196 9.96247 3.1663 9.6842 2.9798L7.85016 1.75053Z"
        fill="currentColor"
      />
      <path
        d="M24.8125 9.35205C24.977 9.32084 25.1357 9.4289 25.167 9.59343C25.1982 9.75797 25.0901 9.9167 24.9256 9.94794L7.33547 13.284C7.17093 13.3152 7.01219 13.2072 6.98095 13.0426C6.94975 12.8781 7.0578 12.7193 7.22233 12.6881L24.8125 9.35205Z"
        fill="currentColor"
      />
      <path
        d="M24.8327 12.6853C24.999 12.6653 25.15 12.7838 25.17 12.9501C25.1901 13.1164 25.0715 13.2674 24.9053 13.2874L7.31513 15.4104C7.14886 15.4304 6.99786 15.3119 6.97779 15.1456C6.95776 14.9793 7.0763 14.8283 7.24257 14.8083L24.8327 12.6853Z"
        fill="currentColor"
      />
      <path
        d="M7.7333 14.0479C7.7333 13.6291 7.39384 13.2897 6.9751 13.2897C6.55636 13.2897 6.21691 13.6291 6.21691 14.0479C6.21691 14.4666 6.55636 14.8061 6.9751 14.8061C7.39384 14.8061 7.7333 14.4666 7.7333 14.0479ZM8.33986 14.0479C8.33986 14.8016 7.72884 15.4126 6.9751 15.4126C6.22137 15.4126 5.61035 14.8016 5.61035 14.0479C5.61035 13.2941 6.22137 12.6831 6.9751 12.6831C7.72884 12.6831 8.33986 13.2941 8.33986 14.0479Z"
        fill="currentColor"
      />
      <path
        d="M32.7542 16.1706C32.7542 15.8356 32.4827 15.5641 32.1477 15.5641C31.8127 15.5641 31.5411 15.8356 31.5411 16.1706C31.5411 16.5056 31.8127 16.7772 32.1477 16.7772C32.4827 16.7772 32.7542 16.5056 32.7542 16.1706ZM33.3608 16.1706C33.3608 16.8406 32.8177 17.3837 32.1477 17.3837C31.4777 17.3837 30.9346 16.8406 30.9346 16.1706C30.9346 15.5006 31.4777 14.9575 32.1477 14.9575C32.8177 14.9575 33.3608 15.5006 33.3608 16.1706Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
